export default "__VITE_ASSET__CnTj9wKx__"